import {default as text} from './TextAdFormat';
import {default as image} from './ImageAdFormat';

export default {
    text,
    image,
};